import {createSelector, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {CursorType, SearchUser} from 'shared/types'

export type initialStateProps = {
  cursor: CursorType
  list: (SearchUser & {isRemoved?: boolean})[]
}

const initialState: initialStateProps = {
  cursor: '',
  list: []
}

export const favoriteModel = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    addItemsFavoriteList: (state, {payload}: PayloadAction<{cursor: CursorType, data: SearchUser[]}>) => {
      state.cursor = payload.cursor
      state.list.push(...payload.data)
    },
    hideFavoriteInList: (state, {payload}: PayloadAction<{id: string, isRemoved?: boolean}>) => {
      state.list = state.list.map((item) => item.id === payload.id ? {...item, isRemoved: payload.isRemoved} : item)
    },
    clearFavorites: () => initialState
  }
})

export const {addItemsFavoriteList, hideFavoriteInList, clearFavorites} = favoriteModel.actions

export const useFavoriteList = () => useSelector(
  createSelector(
    (state: RootState) => state.favorites.list,
    (list) => list
  )
)

export const useFavoriteCursor = () => useSelector(
  createSelector(
    (state: RootState) => state.favorites.cursor,
    (cursor) => cursor
  )
)